import { Component, ViewChild, OnInit } from '@angular/core';
import { Apollo, QueryRef, gql } from 'apollo-angular';
import { Chart } from 'chart.js';

import { ContratistaService } from 'src/app/services/contratista.service';
import { LoginService } from 'src/app/services/login.service';
import { DocumentoService } from 'src/app/services/documento.service';
import { GestorService } from 'src/app/services/gestor.service';
import { EstadoService } from 'src/app/services/estado.service';
import { TransportistaService } from 'src/app/services/transportista.service';
import { CentroService } from 'src/app/services/centro.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ClienteService } from 'src/app/services/cliente.service';
import { ConfirmacionService } from 'src/app/services/confirmacion.service';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { InstalacionService } from 'src/app/services/instalacion.service';
import { Router } from '@angular/router';
import { BreakingChangeType } from 'graphql';

@Component({
  selector: 'app-inicio-entidad-contratista',
  templateUrl: './inicio-entidad-contratista.component.html',
  styleUrls: ['./inicio-entidad-contratista.component.scss']
})
export class InicioEntidadContratistaComponent implements OnInit {

  public userLogged: any

  @ViewChild('doughnutCanvasCentros') doughnutCanvasCentros: any;
  @ViewChild('doughnutCanvasPropio') doughnutCanvasPropio: any;
  @ViewChild('doughnutCanvasGestores') doughnutCanvasGestores: any;
  @ViewChild('doughnutCanvasTransportistas') doughnutCanvasTransportistas: any;
  @ViewChild('doughnutCanvasClientes') doughnutCanvasClientes: any;
  @ViewChild('doughnutCanvasInstalaciones') doughnutCanvasInstalaciones: any;



  title_centros = 'Centros';
  title_clientes = 'Clientes';
  title_propio = 'Documentación propia';
  title_gestores = 'Gestores';
  title_transportistas = 'Transportistas';
  title_instalaciones = 'Instalaciones';

  barChart: any;
  doughnutChart: any;
  lineChart: any;
  doughnutChartCentros: any;
  doughnutChartPropio: any;
  doughnutChartGestores: any;
  doughnutChartTransportistas: any;
  doughnutChartClientes: any;
  doughnutChartInstalaciones: any;

  public data: any
  public loading: any
  //Doc Propia
  public documentos: any
  public documentosActivos: any
  public documentosEnfecha: any
  public countPropioVerde: any
  public dataPropia: any
  public dataGestor: any
  public documentosCaducados: any
  public documentosProximos: any
  public countPropioRojo: any
  public countPropioAmarillo: any


  public docPropio: any[] = []
  public allDocs: any[] = []
  public allDocsActivos: any[] = []
  allDocumentos: any = []

  //Gestores
  idGestorContratista: any = []
  gestoresContratista: any
  gestoresRojos: any = []
  gestoresVerdes: any = []
  gestoresAmarillos: any = []


  //Transportistas
  idTransportistaContratista: any = []
  transportistaContratista: any
  transportistasRojos: any = []
  transportistasVerdes: any = []
  transportistasAmarillos: any = []

  //Centros
  idCentrosContratista: any = []
  centroContratista: any
  centrosRojos: any = []
  centrosVerdes: any = []
  centrosAmarillos: any = []

  //Clientes
  idClientesContratista: any = []
  clienteContratista: any
  clientesRojos: any = []
  clientesVerdes: any = []
  clientesAmarillos: any = []

  constructor(private apollo: Apollo, private contratistaService: ContratistaService, private loginService: LoginService,
    private documentoService: DocumentoService, private gestorService: GestorService, private estadoService: EstadoService, private transportistaService: TransportistaService, private centroService: CentroService, private clienteService: ClienteService, private confirmacionService: ConfirmacionService, private usuarioService: UsuariosService, private router: Router) {
    this.userLogged = loginService.getUserData()
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    this.getDocumentosByContratista()
    this.getAllDocumentos()
    this.getGestoresByContratista()
    this.getTransportistasByContratista()
    this.getCentrosByContratista()
    this.getClientesByContratista()
    this.getUsuarioById(this.userLogged.id)

    this.setIndicadores()
  }

  validarUltimoEstado(data: any) {
    let result = data.map((item: any) => {
      let docsRojos = item.documentos.filter((doc: any) => (doc.tipo === 'activo' || doc.tipo === 'enEspera') && doc.estado === "rojo");
      let docsAmarillos = item.documentos.filter((doc: any) => (doc.tipo === 'activo' || doc.tipo === 'enEspera') && doc.estado === "amarillo");
      let docsVerdes = item.documentos.filter((doc: any) => (doc.tipo === 'activo' || doc.tipo === 'enEspera') && doc.estado === "verde");
      if (docsRojos.length > 0)
        return {
          id: item.id,
          estado: "rojo"
        }
      else if (docsAmarillos.length > 0 && docsRojos.length === 0)
        return {
          id: item.id,
          estado: "amarillo"
        }
      else if (docsVerdes.length > 0 && docsAmarillos.length === 0 && docsRojos.length === 0)
        return {
          id: item.id,
          estado: "verde"
        }
      else {
        return {
          id: item.id,
          estado: "rojo"
        }
      }
    })
    return result;
  }

  checkUltimoEstado(data: any) {
    data.forEach((item: any) => {
      let filtrados = item.documentos.filter((doc: any) => doc.tipo === "activo" || doc.tipo === "enEspera");
      let rojos = filtrados.some((r: any) => r.estado === "rojo");
      let amarillos = filtrados.some((y: any) => y.estado === "amarillo");
      let verdes = filtrados.some((g: any) => g.estado === "verde");
      if (rojos)
        item.estado = "rojo"
      else if (amarillos && !rojos)
        item.estado = "amarillo"
      else if (verdes && !amarillos && !rojos)
        item.estado = "verde"
    })
  }

  checkTiposDocumentos(data: any[], obj: any) {
    let reds = data.some((i: any) => i.estado === "rojo")
    let yellows = data.some((i: any) => i.estado === "amarillo")
    let greens = data.some((i: any) => i.estado === "verde")
    if (reds)
      obj.estado = "rojo"
    else if (yellows && !reds)
      obj.estado = "amarillo"
    else if (greens && !yellows && !reds)
      obj.estado = "verde"
  }



  getDocumentosByContratista() {
    this.dataPropia = [];
    this.apollo.watchQuery<any>({
      query: this.documentoService.getDocumentosByContratista(),
      fetchPolicy: 'no-cache',
      variables: {
        "id": this.userLogged.contratista.id,
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.loading = loading
        this.data = data
        this.documentos = this.data.contratista.documentos

        this.documentosActivos = this.documentos.filter((documento: any) =>
          documento.tipo === 'haciendaActivo' || documento.tipo === 'seguridadSocialActivo'
          || documento.tipo === 'haciendaActivoEnEspera' || documento.tipo === 'seguridadSocialActivoEnEspera')


        this.documentosEnfecha = this.documentosActivos.filter((documento: any) => documento.enFecha)
        this.documentosCaducados = this.documentosActivos.filter((documento: any) => documento.caducado)
        this.documentosProximos = this.documentosActivos.filter((documento: any) => documento.proximoCaduca)

        this.countPropioVerde = parseInt(this.documentosEnfecha.length)
        this.countPropioRojo = parseInt(this.documentosCaducados.length)
        this.countPropioAmarillo = parseInt(this.documentosProximos.length)

        if (this.countPropioVerde != null || this.countPropioVerde != 'undefined') {
          this.dataPropia.push(parseInt(this.countPropioVerde))
        }
        if (this.countPropioAmarillo != null || this.countPropioAmarillo != 'undefined') {
          this.dataPropia.push(parseInt(this.countPropioAmarillo))
        }
        if (this.countPropioRojo != null || this.countPropioRojo != 'undefined') {
          this.dataPropia.push(parseInt(this.countPropioRojo))
        }

        this.doughnutChartPropioMethod();
      })
  }



  doughnutChartPropioMethod() {
    this.doughnutChartPropio = new Chart(this.doughnutCanvasPropio.nativeElement, {
      type: 'doughnut',
      options: {
        responsive: true
      },

      data: {
        labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
        datasets: [{
          label: 'Estados',
          data: this.dataPropia,
          backgroundColor: [
            '#00A131',
            '#FF9E00',
            '#DC3737'

          ],
          hoverBackgroundColor: [
            '#308F70',
            '#EDB355',
            '#EE5B5B'
          ]
        }]
      }
    });
  }



  doughnutChartGestoresMethod() {

    const data = [this.gestoresVerdes.length, this.gestoresAmarillos.length, this.gestoresRojos.length]

    this.doughnutChartGestores = new Chart(this.doughnutCanvasGestores.nativeElement, {
      type: 'doughnut',

      data: {
        labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
        datasets: [{
          label: 'Estados',
          data: data,

          backgroundColor: [
            '#00A131',
            '#FF9E00',
            '#DC3737'

          ],
          hoverBackgroundColor: [
            '#308F70',
            '#EDB355',
            '#EE5B5B'
          ]
        }]
      }
    })
  }
  showDataGestores(evt: any) {
    let data = this.doughnutChartGestores.getElementsAtEvent(evt)
    //console.log(data[0]._model);
    switch (data[0]._model.backgroundColor) {
      case '#308F70':
        this.filterGreenGestor()
        break;
      case '#EDB355':
        this.filterYellowGestor()
        break;
      case '#EE5B5B':
        this.filterRedGestor()
        break;

      default:
        break;
    }

  }

  showDataTransportistas(evt: any) {
    let data = this.doughnutChartTransportistas.getElementsAtEvent(evt)
    /* let clickedDatasetIndex = data[0]._datasetIndex;
    let clickedElementindex = data[0]._index;
    let label = this.doughnutChartTransportistas.data.labels[clickedElementindex];
    let value = this.doughnutChartTransportistas.data.datasets[clickedDatasetIndex].data[clickedElementindex];     
    alert("Clicked: " + label + " - " + value); */
    //console.log(data[0]._model.backgroundColor)
    switch (data[0]._model.backgroundColor) {
      case '#308F70':
        this.filterGreenTransportistas()
        break;
      case '#EDB355':
        this.filterYellowTransportistas()
        break;
      case '#EE5B5B':
        this.filterRedTransportistas()
        break;

      default:
        break;
    }

  }

  showDataCentros(evt: any) {
    let data = this.doughnutChartCentros.getElementsAtEvent(evt)
   // console.log(data[0]._model);
    switch (data[0]._model.backgroundColor) {
      case '#308F70':
        this.filterGreenCentros()
        break;
      case '#EDB355':
        this.filterYellowCentros()
        break;
      case '#EE5B5B':
        this.filterRedCentros()
        break;

      default:
        break;
    }

  }

  showDataClientes(evt: any) {
    let data = this.doughnutChartClientes.getElementsAtEvent(evt)
    //console.log(data[0]._model);
    switch (data[0]._model.backgroundColor) {
      case '#308F70':
        this.filterGreenClientes()
        break;
      case '#EDB355':
        this.filterYellowClientes()
        break;
      case '#EE5B5B':
        this.filterRedClientes()
        break;

      default:
        break;
    }

  }
  doughnutChartCentrosMethod() {

    const data = [this.centrosVerdes.length, this.centrosAmarillos.length, this.centrosRojos.length]

    this.doughnutChartCentros = new Chart(this.doughnutCanvasCentros.nativeElement, {
      type: 'doughnut',

      data: {
        labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
        datasets: [{
          label: 'Estados',
          data: data,
          backgroundColor: [
            '#00A131',
            '#FF9E00',
            '#DC3737'

          ],
          hoverBackgroundColor: [
            '#308F70',
            '#EDB355',
            '#EE5B5B'
          ]
        }]
      }
    });
  }


  doughnutChartTransportistasMethod() {
    const data = [this.transportistasVerdes.length, this.transportistasAmarillos.length, this.transportistasRojos.length]
    this.doughnutChartTransportistas = new Chart(this.doughnutCanvasTransportistas.nativeElement, {
      type: 'doughnut',

      data: {
        labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
        datasets: [{
          label: 'Estados',
          data: data,
          backgroundColor: [
            '#00A131',
            '#FF9E00',
            '#DC3737'

          ],
          hoverBackgroundColor: [
            '#308F70',
            '#EDB355',
            '#EE5B5B'
          ]
        }]
      }
    });
  }

  doughnutChartClientesMethod() {
    const data = [this.clientesVerdes.length, this.clientesAmarillos.length, this.clientesRojos.length]
    this.doughnutChartClientes = new Chart(this.doughnutCanvasClientes.nativeElement, {
      type: 'doughnut',

      data: {
        labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
        datasets: [{
          label: 'Estados',
          data: data,
          backgroundColor: [
            '#00A131',
            '#FF9E00',
            '#DC3737'

          ],
          hoverBackgroundColor: [
            '#308F70',
            '#EDB355',
            '#EE5B5B'
          ]
        }]
      },
    });
  }


  setIndicadores() {

    this.setDocumentoProximoCaduca()
    this.setDocumentoCaducado()
    this.setDocumentoEnFecha()


  }
  filterYellowGestor() {

    this.apollo.watchQuery<any>({
      query: this.contratistaService.getGestoresYellowContratista(),
      variables: {
        "id": this.userLogged.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
       // console.log(data)
        this.gestorService.setGestores(data.contratista.gestores)
        this.router.navigate(['/contratista/estado/gestores']);
      })

  }

  filterGreenGestor() {

    this.apollo.watchQuery<any>({
      query: this.contratistaService.getGestoresGreenContratista(),
      variables: {
        "id": this.userLogged.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.gestorService.setGestores(data.contratista.gestores)
        this.router.navigate(['/contratista/estado/gestores']);
      })

  }

  filterRedGestor() {

    this.apollo.watchQuery<any>({
      query: this.contratistaService.getGestoresRedContratista(),
      variables: {
        "id": this.userLogged.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.gestorService.setGestores(data.contratista.gestores)
        this.router.navigate(['/contratista/estado/gestores']);
      })

  }

  filterYellowTransportistas() {

    this.apollo.watchQuery<any>({
      query: this.contratistaService.getTransportistasYellowContratista(),
      variables: {
        "id": this.userLogged.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.transportistaService.setTransportistas(data.contratista.transportistas)
        this.router.navigate(['/contratista/estado/transportistas']);
      })
  }

  filterGreenTransportistas() {

    this.apollo.watchQuery<any>({
      query: this.contratistaService.getTransportistasGreenContratista(),
      variables: {
        "id": this.userLogged.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.transportistaService.setTransportistas(data.contratista.transportistas)
        this.router.navigate(['/contratista/estado/transportistas']);
      })

  }

  filterRedTransportistas() {

    this.apollo.watchQuery<any>({
      query: this.contratistaService.getTransportistasRedContratista(),
      variables: {
        "id": this.userLogged.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.transportistaService.setTransportistas(data.contratista.transportistas)
        this.router.navigate(['/contratista/estado/transportistas']);
      })

  }

  filterYellowCentros() {

    this.apollo.watchQuery<any>({
      query: this.contratistaService.getCentrosYellowContratista(),
      variables: {
        "id": this.userLogged.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.centroService.setCentros(data.contratista.centros)
        this.router.navigate(['/contratista/estado/centros']);
      })
  }

  filterGreenCentros() {

    this.apollo.watchQuery<any>({
      query: this.contratistaService.getCentrosGreenContratista(),
      variables: {
        "id": this.userLogged.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.centroService.setCentros(data.contratista.centros)
        this.router.navigate(['/contratista/estado/centros']);
      })

  }

  filterRedCentros() {

    this.apollo.watchQuery<any>({
      query: this.contratistaService.getCentrosRedContratista(),
      variables: {
        "id": this.userLogged.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.centroService.setCentros(data.contratista.centros)
        this.router.navigate(['/contratista/estado/centros']);
      })
  }

  filterYellowClientes() {

    this.apollo.watchQuery<any>({
      query: this.contratistaService.getClientesYellowContratista(),
      variables: {
        "id": this.userLogged.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.clienteService.setClientes(data.contratista.clientes)
        this.router.navigate(['/contratista/estado/clientes']);
      })
  }

  filterGreenClientes() {

    this.apollo.watchQuery<any>({
      query: this.contratistaService.getClientesGreenContratista(),
      variables: {
        "id": this.userLogged.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.clienteService.setClientes(data.contratista.clientes)
        this.router.navigate(['/contratista/estado/clientes']);
      })

  }

  filterRedClientes() {

    this.apollo.watchQuery<any>({
      query: this.contratistaService.getClientesRedContratista(),
      variables: {
        "id": this.userLogged.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.clienteService.setClientes(data.contratista.clientes)
        this.router.navigate(['/contratista/estado/clientes']);
      })
  }





  getAllDocumentos() {
    this.apollo.watchQuery<any>({
      query: this.documentoService.getAllDocumentos(),
      fetchPolicy: 'no-cache',
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {

        this.allDocumentos = data.documentos


      })
  }

  setDocumentoProximoCaduca() {
    this.allDocumentos.map((documento: any) => {

      if (documento?.fechaCaducidad <= this.documentoService.getNextMonth() && documento?.fechaCaducidad > this.documentoService.getActualDate() && documento.fechaCheck != this.documentoService.getActualDate()) {

        this.updateDocumentoToProximoCaduca(documento?.id)
      }
    })
  }



  updateDocumentoToProximoCaduca(id: string) {
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id,
          },
          "data": {
            "proximoCaduca": true,
            "caducado": false,
            "enFecha": false,
            "estado": "amarillo",
            "fechaCheck": this.documentoService.getActualDate()
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa', error)
      })
  }

  setDocumentoCaducado() {

    this.allDocumentos.map((documento: any) => {
      if (documento.fechaCaducidad <= this.documentoService.getActualDate() && documento.fechaCheck != this.documentoService.getActualDate()) {
        this.updateDocumentoToCaducado(documento.id)
      }
    })
  }

  updateDocumentoToCaducado(id: string) {

    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "caducado": true,
            "proximoCaduca": false,
            "enFecha": false,
            "estado": "rojo",
            "fechaCheck": this.documentoService.getActualDate()

          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log(error)
      })
  }

  setDocumentoEnFecha() {
    this.allDocumentos.map((documento: any) => {
      if (documento.fechaCaducidad > this.documentoService.getNextMonth() && documento.fechaCaducidad > this.documentoService.getActualDate() && documento.fechaCheck != this.documentoService.getActualDate()) {
        this.updateDocumentoToEnFecha(documento.id)
      }
      if (documento.noCaduca && documento.fechaCheck != this.documentoService.getActualDate()) {
        this.updateDocumentoToEnFecha(documento.id)
      }
    })
  }

  updateDocumentoToEnFecha(id: string) {
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "caducado": false,
            "proximoCaduca": false,
            "enFecha": true,
            "estado": "verde",
            "fechaCheck": this.documentoService.getActualDate()
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa', error)
      })
  }

  getGestoresByContratista() {
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getGestoresByContratistaDoughnout(),
      fetchPolicy: "no-cache",
      variables: {
        "id": this.userLogged.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        const gestoresContratista = data.contratista.gestores
        let checkUltimoEstado = this.validarUltimoEstado(gestoresContratista)

        checkUltimoEstado?.forEach((gestor: any) => {

          switch (gestor.estado) {
            case 'rojo':
              this.gestoresRojos.push(gestor)

              break;
            case 'amarillo':
              this.gestoresAmarillos.push(gestor)

              break;
            case 'verde':
              this.gestoresVerdes.push(gestor)

              break;

          }

        });
        this.doughnutChartGestoresMethod()
      }
      )
  }





  getTransportistasByContratista() {
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getTransportistasByContratistaDoughnout(),
      fetchPolicy: "no-cache",
      variables: {
        "id": this.userLogged.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        const transportistaContratista = data.contratista.transportistas
        let checkUltimoEstado = this.validarUltimoEstado(transportistaContratista)

        checkUltimoEstado?.forEach((transportista: any) => {


          switch (transportista.estado) {
            case 'rojo':
              this.transportistasRojos.push(transportista)

              break;
            case 'amarillo':
              this.transportistasAmarillos.push(transportista)

              break;
            case 'verde':
              this.transportistasVerdes.push(transportista)

              break;

          }



        });
        this.doughnutChartTransportistasMethod()
      }
      )
  }




  getCentrosByContratista() {
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getCentrosByContratistaDoughnout(),
      fetchPolicy: "no-cache",
      variables: {
        "id": this.userLogged.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        //console.log(data)
        this.centroContratista = data.contratista.centros
        this.centroContratista?.forEach((centro: any) => {
          let filtrados = centro.documentos.filter((doc: any) =>
            doc.tipo === "activo" || doc.tipo === "esEspera"
          )
          if (filtrados.length === 0) {
            centro.estado = "rojo"
          } else {
            let hasDocAmarillo = filtrados.some((cent: any) => cent.estado === "amarillo")
              if (hasDocAmarillo){
                centro.estado = "amarillo"
              }
            let hasDocsRojo = filtrados.some((cent: any) => cent.estado === "rojo")
            if (!hasDocsRojo && !hasDocAmarillo) {
              this.checkUltimoEstado(centro.gestors)
              this.checkUltimoEstado(centro.transportistas)
              let allCondicion = [...centro.gestors, ...centro.transportistas]
              this.checkTiposDocumentos(allCondicion, centro)
            } else if (hasDocsRojo){
              centro.estado = "rojo"
            }
          }
          switch (centro.estado) {

            case 'rojo':
              this.centrosRojos.push(centro)
              break;

            case 'amarillo':
              this.centrosAmarillos.push(centro)
              break;
            case 'verde':
              this.centrosVerdes.push(centro)
              break;

          }
          /* const filtroRojo = allCondicion.filter((element: any) => element.estado == 'rojo')
          console.log(filtroRojo)
              if (filtroRojo.length > 0) {
                centroRojo.push(centro)
              }
              const filtroAmarillo = allCondicion.filter((element: any) => element.estado != 'rojo' && element.estado == 'amarillo')
              if (filtroAmarillo.length > 0) {
                centroAmarillo.push(centro)
              }

              const filtroVerde = allCondicion.filter((element: any) => element.estado != 'rojo' && element.estado != 'amarillo' && element.estado == 'verde')
              if (filtroVerde.length > 0) {
                centroVerde.push(centro)
              } */

        });
        this.doughnutChartCentrosMethod()
      }
      )
  }



  getClientesByContratista() {
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getClientesByContratistaDoughnout(),
      fetchPolicy: "no-cache",
      variables: {
        "id": this.userLogged.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        const clienteContratista = data.contratista.clientes
        clienteContratista?.forEach((cliente: any) => {
          this.checkUltimoEstado(cliente.centros)
          let hasDocumentosRojos = cliente.centros.some((cent: any) => cent.estado === "rojo")
          if (!hasDocumentosRojos) {
            //chequear docuementos de gestores y transportistas por centro
            cliente.centros.forEach((centro: any) => {
              this.checkUltimoEstado(centro.gestors)
              this.checkUltimoEstado(centro.transportistas)
              let allTranspYGestores = [...centro.gestors, ...centro.transportistas]
              this.checkTiposDocumentos(allTranspYGestores, centro)
            })
            this.checkTiposDocumentos(cliente.centros, cliente)
          } else {
            cliente.estado = "rojo";
          }

          switch (cliente?.estado) {

            case 'rojo':
              this.clientesRojos.push(cliente);
              break;

            case 'amarillo':


              this.clientesAmarillos.push(cliente);

              break;




            case 'verde':



              this.clientesVerdes.push(cliente);

              break;


          }
        });
        this.doughnutChartClientesMethod();
      }
      )
  }



  updateClienteById(id: any, estado: any) {
    this.apollo.mutate({
      mutation: this.clienteService.updateCliente(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "estado": estado
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa', error)
      })


  }

  getUsuarioById(id: any) {
    this.apollo.watchQuery<any>({
      query: this.usuarioService.getUsuariosById(),
      fetchPolicy: "no-cache",
      variables: {
        id,
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        if (data.user.mensaje) {
          this.confirmacionService.openPopUp(
            'Documento Rechazado',
            data.user.mensaje
          );
          this.updateUser(id)
        }

      })
  }

  updateUser(id: any) {
    this.apollo.mutate({
      mutation: this.usuarioService.updateUsuario(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "mensaje": null
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log(data);

      }, (error) => {
        /* console.log('aaaaa',error) */
      })
  }

}
